//////////////////////////////////////////////////////////////////////
//
//  09/26/18
//  src/store/actionTypes.js
//
//  This file lists all the 'actions' that can take place in the 
//  CityBiz project.
//
//  Note: Every 'action' must be listed here and every 'action' 
//  must be unique!
//

// Error Section
export const ERROR_ADD    = "ADD_ERROR";
export const ERROR_REMOVE = "REMOVE_ERROR";

// Navbar Section
export const NAV_CKBOX_CH = "CHECK_BOX_CHANGE NAV";
export const NAV_TOPST_CH = "TOP_STATE_CHANGE_NAV";
export const NAV_BOTH_CH  = "BOTH_CHANGE_NAV";

// User Section
export const USER_SET     = "SET_USER";

// Favorites Section
export const FAV_ADD      = "ADD_FAVORITE";
export const FAV_REMOVE   = "REMOVE_FAVORITE";



// WEBPACK FOOTER //
// ./src/store/actionTypes.js